<div class="cardModal">
    <div class="cardContent">
        <header>
            <i class="fa fa-warning fa-3x"></i>
            <h2>{{ 'exports.full-export.modal.fullExportConfirmation' | translate }}</h2>
        </header>
        <div class="text-body">
            <p>{{ 'exports.full-export.modal.fullExportConfirmationText' | translate }}</p>
        </div>
        <table>
            <tr>
                <th>{{ 'exports.full-export.modal.channel' | translate }}:&nbsp;</th>
                <td>{{ data.data.channelId }}</td>
            </tr>
            <tr>
                <th>{{ 'exports.full-export.modal.fullExport' | translate }}:&nbsp;</th>
                <td>{{ data.data.exportType + '.label' | translate }} <br /></td>
            </tr>
            <tr>
                <th></th>
                <td>
                    <div class="infoNotification warning">
                        <i class="far fa-warning"></i>
                        {{ data.data.exportType + '.warning' | translate }}
                    </div>
                </td>
            </tr>
            <tr>
                <th>{{ 'exports.full-export.modal.shijiIDs' | translate }}:&nbsp;</th>
                <td>
                    <div class="scrollable-mappings">
                        {{ data.data.listingMappingIds.join(', ') }}
                    </div>
                </td>
            </tr>
        </table>
    </div>

    <div class="cardFooter">
        <div class="buttonArea stickyBottom">
            <button type="button" class="button primary" (click)="closeModalInstance(true)">
                {{ 'generalKeywords.confirm' | translate }}
            </button>
            <button type="button" class="button" (click)="closeModalInstance(false)">{{ 'generalKeywords.cancel' | translate }}</button>
        </div>
    </div>
</div>
